import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ModuleManager } from "../../Managers/ModuleManager";
import { GambleUserControls } from "../Common/UserControls/GambleUserControls";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopGambleUserControls extends GambleUserControls {
    // activate base background animations if we start game at gamble scene
    initIntro(): void {
        // ModuleManager.setActiveSceneBackground(GameModules.Base, 0);

        super.initIntro();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopGambleUserControls.ts
 **/